/**
 * Created by ganlu on 27/12/2016.
 */
export default () => {

    //Fancybox-Plus JavaScript API reference:
    // http://igorlino.github.io/fancybox-plus/api.htm

    return {
        fancyboxPlus: fancyboxPlus, //returns the fancyboxplus jquery plugin
        showActivity: showActivity,//Shows loading animation
        hideActivity: hideActivity,//Hides loading animation
        next: next,//Displays the next gallery item
        prev: prev,//Displays the previous gallery item
        pos: pos,//Displays item by index from gallery
        cancel: cancel,//Cancels loading content
        close: close,//Hides FancyBox. Within an iframe use - parent.close();
        resize: resize,//Auto-resizes FancyBox height to match height of content
        center: center,//Centers FancyBox in viewport
        getOptions: getOptions

    };
    ////////////
    function fancyboxPlus() {
        return $.fancyboxPlus;
    }

    function showActivity() {
        fancyboxPlus().showActivity();
    }

    function hideActivity() {
        fancyboxPlus().hideActivity();
    }

    function pos() {
        fancyboxPlus().pos();
    }

    function cancel() {
        fancyboxPlus().cancel();
    }

    function center() {
        fancyboxPlus().center();
    }

    function next() {
        fancyboxPlus().next();
    }

    function prev() {
        fancyboxPlus().prev();
    }

    function close() {
        fancyboxPlus().close();
    }

    function resize() {
        fancyboxPlus().resize();
    }

    function getOptions(titleFormat) {
        let options = {
            transitionIn: 'none',
            transitionOut: 'none',
            padding: 0,
            margin: 100,
            overlayColor: '#000000',
            overlayOpacity: 0.8,
            titlePosition: 'inside',
            autoScale: "true",
            onComplete: function () {
                $('body').addClass('no-scroll');

            },
            onClosed: function () {
                $('body').removeClass('no-scroll');

            }
        };

        if (typeof(titleFormat) == 'function') {
            options['titleFormat'] = titleFormat;
        }
        if(window.innerWidth<767){
            options['margin'] = 20;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/fancybox-plus/fancybox-plus.service.js